import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';

export default function AdminAuth() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [adminExists, setAdminExists] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function checkAdmin() {
      try {
        const { data } = await api.get('/auth/admin-exists');
        setAdminExists(data.exists);
      } catch (err) {
        setError('Không thể kết nối máy chủ, vui lòng thử lại.');
      } finally {
        setChecking(false);
      }
    }
    checkAdmin();
  }, []);

  async function handleRegister(e) {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Mật khẩu phải có ít nhất 6 ký tự');
      return;
    }
    if (password !== confirmPassword) {
      setError('Xác nhận mật khẩu không khớp');
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/admin-register', { username, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('userType', 'admin');
      localStorage.setItem('adminUsername', data.admin.username);
      navigate('/admin');
    } catch (err) {
      if (err.response?.status === 403) setAdminExists(true);
      setError(err.response?.data?.message || 'Đăng ký thất bại, vui lòng thử lại');
    } finally {
      setLoading(false);
    }
  }

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/admin-login', { username, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('userType', 'admin');
      localStorage.setItem('adminUsername', data.admin.username);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Sai tài khoản hoặc mật khẩu Admin');
    } finally {
      setLoading(false);
    }
  }

  if (checking) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.loading}>Đang kết nối máy chủ...</div>
        </div>
      </div>
    );
  }

  if (!adminExists) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.title}>Khởi Tạo Admin</div>
          <div style={styles.notice}>
            Hệ thống chưa có tài khoản Admin. Đăng ký khởi tạo lần đầu duy nhất.
          </div>
          {error && <div style={styles.error}>{error}</div>}
          <form onSubmit={handleRegister}>
            <label style={styles.label}>Username Admin:</label>
            <input
              style={styles.input}
              placeholder="Tên đăng nhập"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label style={styles.label}>Mật khẩu:</label>
            <input
              style={styles.input}
              placeholder="Tối thiểu 6 ký tự"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label style={styles.label}>Xác nhận mật khẩu:</label>
            <input
              style={styles.input}
              placeholder="Nhập lại mật khẩu"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button style={styles.button} type="submit" disabled={loading}>
              {loading ? 'Đang khởi tạo...' : 'TẠO TÀI KHOẢN ADMIN'}
            </button>
          </form>
          <Link to="/login" style={styles.backLink}>← Quay lại đăng nhập Máy Xem</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.title}>Quản Trị Viên</div>
        <div style={styles.subtitle}>Đăng nhập dành cho Admin quản lý</div>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleLogin}>
          <label style={styles.label}>Tên đăng nhập Admin:</label>
          <input
            style={styles.input}
            placeholder="Username Admin"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <label style={styles.label}>Mật khẩu Admin:</label>
          <input
            style={styles.input}
            placeholder="Mật khẩu"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Đang đăng nhập...' : 'ĐĂNG NHẬP ADMIN'}
          </button>
        </form>
        <Link to="/login" style={styles.backLink}>← Quay lại đăng nhập Máy Xem</Link>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0f172a',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    padding: '16px',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: 380,
    backgroundColor: '#1e293b',
    borderRadius: 16,
    padding: '24px 20px',
    color: '#f8fafc',
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
    border: '1px solid #334155',
    boxSizing: 'border-box',
  },
  title: { fontSize: 20, fontWeight: 800, marginBottom: 4, textAlign: 'center', color: '#f8fafc' },
  subtitle: { fontSize: 13, color: '#94a3b8', textAlign: 'center', marginBottom: 20 },
  notice: {
    backgroundColor: 'rgba(245, 158, 11, 0.1)',
    color: '#facc15',
    fontSize: 12,
    padding: '10px',
    borderRadius: 8,
    marginBottom: 16,
    textAlign: 'center',
    border: '1px solid rgba(245, 158, 11, 0.2)',
  },
  label: { fontSize: 12, color: '#94a3b8', marginBottom: 4, display: 'block' },
  input: {
    width: '100%',
    height: 46,
    padding: '0 14px',
    borderRadius: 10,
    border: '1px solid #334155',
    backgroundColor: '#0f172a',
    color: '#f8fafc',
    marginBottom: 14,
    fontSize: 15,
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    height: 48,
    borderRadius: 10,
    border: 'none',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    marginTop: 8,
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
  },
  error: {
    color: '#f87171',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    padding: '10px',
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 14,
    textAlign: 'center',
    border: '1px solid rgba(239, 68, 68, 0.2)',
  },
  backLink: {
    display: 'block',
    textAlign: 'center',
    marginTop: 18,
    fontSize: 13,
    color: '#94a3b8',
    textDecoration: 'none',
  },
  loading: { color: '#94a3b8', fontSize: 14, textAlign: 'center', padding: '20px 0' },
};